/* lua.js generated code 0.3.0 */

var HeadFrame = xClass("HeadFrame")
HeadFrame.Type_Big = 160
HeadFrame.Type_Middle = 80
HeadFrame.Type_Small = 50
HeadFrame.createHeadFrame = function (frameId, scale, sizeType) {
    if (null == sizeType) {
        sizeType = HeadFrame.Type_Big
    }
    scale = scale || 1
    scale = scale * sizeType / HeadFrame.Type_Big
    sizeType = HeadFrame.Type_Big
    if (null == frameId || frameId === 0) {
        // 初始化默认黄色的头像框
        var head = cc.Sprite.createWithSpriteFrameName("uilibrary/friendboard_circle2.png")
        var headSize = head.getContentSize().width
        head.setScale(sizeType / headSize * scale)
        return head
    }
    var meta = MetaManager.HeadFrameMeta_getFrameMeta(frameId)
    if (null == meta) {
        return null
    }
    var frame = meta.csb_frame
    var fileName = string.format("cocos/" + meta.csb_name, sizeType, sizeType)
    var node = cc.CSLoader.createNode(fileName)
    var frameLevel = meta.level
    var nodeLevel = node.getChildByName("leves")
    var levelLabel = cc.Label.createWithBMFont("font/berlinsansfb_40_bluestroke.fnt", frameLevel)
    // var levelLabel = cc.Label.createWithBMFont("font/berlinsansfb_40_dropshadow.fnt", frameLevel)
    var size = nodeLevel.getContentSize()
    levelLabel.setScale(0.75)
    levelLabel.setPosition(ccp(size.width / 2, size.height / 2 + 3))
    nodeLevel.addChild(levelLabel, 0, "levelLabel")
    node.setContentSize(cc.size(160, 160))
    node.getChildByName("tails").setVisible(false)
    node.timeline = cc.CSLoader.createTimeline(fileName)
    node.runAction(node.timeline)
    frame = frame || 0
    if (scale) {
        node.setScale(scale)
    }
    HeadFrame.changeStep(node, frame)
    cc.log(node)
    return node
}
HeadFrame.hiddenLevel = function (node) {
    var leves = node.getChildByName("leves")
    if (leves) {
        leves.setVisible(false)
    }
}
HeadFrame.changeStep = function (node, frame) {
    node.timeline.gotoFrameAndPause(frame)
}
HeadFrame.ShowArrow = function (node) {
    var tails = node.getChildByName("tails")
    if (tails) {
        tails.setVisible(true)
    }
}
module.exports = HeadFrame
